import moment from 'moment'
import staticData from '../../config/staticData'

moment.locale(staticData.lang)

export default moment
